import React from 'react';
import PropTypes from 'prop-types';

export function MessengerLauncherWrapper({ children }) {
  return (
    <>
      <a className="messenger-launcher-wrapper messenger-launcher-wrapper__intercom">
        {children}
      </a>

      <style jsx>{`
        .messenger-launcher-wrapper {
          font-weight: bold;
        }
      `}</style>
    </>
  );
}

MessengerLauncherWrapper.propTypes = {
  children: PropTypes.node,
};
